module.exports = __webpack_public_path__ + "img/sample-min-3.e75260a9.png";